module.exports = require("js-select");


//////////////////
// WEBPACK FOOTER
// external "js-select"
// module id = 88
// module chunks = 0